import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { deleteTariffFailed, deleteTariffSuccessful } from '../actions';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* deleteTariff(action) {
  try {
    const id = action.payload;

    const url = `${BACKEND_URL}/proxy/tariff/v1/tariffs/${id}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(deleteTariffSuccessful([]));
      yield call(resolveActionPromise(action, {}));
    } else {
      const data = yield dataResponse.json();
      yield put(deleteTariffFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(deleteTariffFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
